var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.25 15.75h-3.25c-1.52 0-2.75-1.23-2.75-2.75v-4c0-1.52 1.23-2.75 2.75-2.75h3.25zm12.34-11.7c-.69-.53-1.57-.69-2.41-.45l-8.43 2.4v9.98l8.46 2.31c.25.07.49.1.74.1.59 0 1.17-.2 1.66-.57.68-.52 1.08-1.32 1.08-2.18v-9.4c0-.87-.4-1.67-1.1-2.19zm-15.32 13.2.01 1.31c.01.6.25 1.16.68 1.58.42.41.97.63 1.56.63h.03c1.21-.02 2.2-1.02 2.2-2.23v-1l-1.05-.29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetter);
export default __webpack_public_path__ + "static/media/news_letter.1e85d63c3ac5a36999ae17386ab67ae1.svg";
export { ForwardRef as ReactComponent };